import { ConnectProto } from "@racoon/api";

/**
 * Jobs edited in an open report. The modal's items are a snapshot, so the header
 * and body read the job from here to show the latest review status and container
 * facts — also when the arrows return to a job (each step remounts the body).
 */
export const createEditedJobs = () => {
  const jobs = new Map<bigint, ConnectProto.Job>();
  // Jobs whose container facts were changed but not written yet.
  const drafts = new Set<bigint>();
  const listeners = new Set<() => void>();

  const store = (job: ConnectProto.Job) => {
    jobs.set(job.id, job);
    listeners.forEach((listener) => listener());
  };

  return {
    get: (job: ConnectProto.Job) => jobs.get(job.id) ?? job,
    /** What the backend has now, e.g. after a save. */
    set: (job: ConnectProto.Job) => {
      drafts.delete(job.id);
      store(job);
    },
    /** Container facts the dispatcher changed: written only with the review status. */
    setDraft: (job: ConnectProto.Job) => {
      drafts.add(job.id);
      store(job);
    },
    isDraft: (job: ConnectProto.Job) => drafts.has(job.id),
    hasDrafts: () => drafts.size > 0,
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
};

export type EditedJobs = ReturnType<typeof createEditedJobs>;
